const isDev = true;

export const LOG = {
  debug: (label: string, data?: unknown) => {
    console.log(`%c ${label}`, "color: grey", data ?? "");
  },
  info: (label: string, data?: unknown) => {
    const stringData = isDev ? data : JSON.stringify(data);
    console.log(
      `%c INFO | ${label}`,
      "background: cornflowerblue; color: black",
      stringData ?? ""
    );
  },
  warn: (label: string, data?: unknown) => {
    const stringData = isDev ? data : JSON.stringify(data);
    console.log(
      `%c WARN | ${label}`,
      "background: orange; color: black",
      stringData ?? ""
    );
  },
  error: (label: string, data?: unknown) => {
    const stringData = isDev ? data : JSON.stringify(data);
    console.log(
      `%c ERROR | ${label}`,
      "background: red; color: white",
      stringData ?? ""
    );
  },
};
